import ScrollOut from "scroll-out";

const btns = document.querySelectorAll(".btn-grupo");

function btnClick() {
    console.log('click', document.getElementById("#compra"))
    location.href = "#compra";
    // document.getElementById("#compra").scrollIntoView();
}
btns.forEach(item => item.addEventListener('click', btnClick));

// CLICK COMPRA
const btnCompra = document.getElementById('btnCompra')
btnCompra.addEventListener('click', () => {
    console.log('btnCompra', btnCompra)
    window.location.href = 'https://pay.hotmart.com/Q82931384M?off=hb3f7qrv&bid=1694277911333'
})

ScrollOut({
    onShown(el) {
        // el.classList.add("animated");
        // remove the class
        el.classList.remove("animated");

        // force reflow
        void el.offsetWidth;

        // re-add the animated cl
        el.classList.add("animated");
    }
});